
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, OrderTiss, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class OrderTissListProvider implements Resolve<any> {
    orderTiss: OrderTiss[];
    orderTissEdit: OrderTiss;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(public gw: ApiGateway, private location: Location) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.orderTissEdit = this.state?.currentOrderTiss;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        } else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = "id";
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getPage(this.pageOptions)]).then(() => {
                resolve();
            }, reject);
        });
    }

    get(id: number): Observable<OrderTiss> {
        if (!id) {
            return null;
        }
        return this.gw.get("order/tiss/:id", { id: id });
    }

    get currentOrderTiss(): OrderTiss {
        return this.orderTissEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("orderTiss/").subscribe((res: HttpResponse<any>) => {
                this.orderTiss = res.body;
                resolve(res);
            }, reject);
        });
    }

    getContraptionInsurance(insuranceId) {
        return new Promise<any>((resolve, reject) => {
            this.gw.get(`insurance/${insuranceId}/contraption`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post("orderTiss/search", pageOptions)
                .subscribe((res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(this.orderTiss, res.body.content) &&
                        res.body.content.length > 0
                    ) {
                        this.orderTiss = res.body.content;
                        this.onDataChanged.next(this.orderTiss);
                    } else {
                        this.orderTiss = res.body.content;
                    }
                    resolve(res);
                }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

